export default class ValidationState {
  public name: string = "";
  public isValid: boolean | undefined = undefined;
  public renderCallback: any = undefined;
}
